import Work1 from "../../assets/winner-1.png";
import Work2 from "../../assets/winner-2.png";
import Work3 from "../../assets/winner-3.png";
import Work4 from "../../assets/winner-4.png";
import Work5 from "../../assets/winner-5.png";
import Work6 from "../../assets/winner-6.png";

const Menu = [
  {
    id: 1,
    image: Work5,
    title: "Gold Medalist - Ranked 1st in Department",
    category: ["Academic Excellence"],
    url: "https://drive.google.com/file/d/1Y5efjJ2G5sbBStuiJF6x51myYPf5HzXn/view?usp=drivesdk",
  },
  {
    id: 2,
    image: Work6,
    title: "Best Paper Award – Oral Cancer Detection using Deep Learning",
    category: ["Research Achievement"],
    url: "https://drive.google.com/file/d/1YyByrWz2B4t37RGI-Z07_eMiOw5tzP-A/view?usp=drivesdk",
  },
  {
    id: 3,
    image: Work1,
    title: "Winner – All India Neo Codeathon 2024",
    category: ["Codeathon Winner"],
    url: "https://drive.google.com/file/d/1TWLyRruS8-JgnGA90t16oeG9TkjNaZWZ/view?usp=sharing",
    // url:"winner-1.png"
  },
  {
    id: 4,
    image: Work4,
    title: "2nd Rank Holder – Third Year",
    category: ["Academic Excellence"],
    url: "https://drive.google.com/file/d/1mQCwwWngOvG0hqDqOVO-lqMflSMshTfE/view?usp=drive_link",
  },
  {
    id: 5,
    image: Work3,
    title: "1st Rank Holder – Second Year",
    category: ["Academic Excellence"],
    url: "https://drive.google.com/file/d/1ENk3gZgxwTmr-8LqOQj0R0qIP7s8Z-aE/view?usp=sharing",
  },
  {
    id: 6,
    image: Work2,
    title: "1st Rank Holder – First Year",
    category: ["Academic Excellence"],
    url: "https://drive.google.com/file/d/1RGChb1jpM1M7yL4aYJV-mY7Aq-40FAxp/view?usp=sharing",
  },
];

export default Menu;
